<template>
  <v-flex>
    <div v-if="isSender"
         class="text-xs-right">
      <small>{{time}}</small>
    </div>

    <p v-if="isSender"
       class="text-xs-right">
      <v-chip color="orange"
              text-color="white">{{message.message}}</v-chip>
    </p>

    <div v-if="!isSender">
      <small>{{time}}</small>
    </div>

    <p v-if="!isSender">
      <v-chip v-if="!isSender"
              color="teal"
              text-color="white">{{message.message}}</v-chip>
    </p>
  </v-flex>
</template>

<script>
import Firebase from 'firebase'
import moment from 'moment'
export default {
  props: [
    'message'
  ],
  computed: {
    time () {
      return moment.unix(this.message.created).format('MM/DD/YYYY hh:mm')
    },
    isSender () {
      var userID = Firebase.auth().currentUser.uid
      if (userID === this.message.sender) {
        return true
      } else {
        return false
      }
    }
  },
  name: 'Message'
}
</script>



// WEBPACK FOOTER //
// src/components/Message.vue